import { Injectable, inject } from '@angular/core';
import { GetDiarysResponse, GetUnreadDiarysResponse, PostDiaryPayload, PutDiaryPayload } from '@schema/APITypes';
import { ApiService } from './api.service';
import queryString from 'query-string';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientDiaryService {
  private apiService = inject(ApiService);

  diaryUnread = new BehaviorSubject<number>(0);

  async postClientDiary(payload: PostDiaryPayload): Promise<void> {
    await this.apiService.post('diary', payload);
    await this.getClientDiaryUnread();
  }

  async putClientDiary(payload: PutDiaryPayload, id: string): Promise<void> {
    await this.apiService.put(`diary/${id}`, payload);
    await this.getClientDiaryUnread();
  }

  async deleteClientDiary(id: string): Promise<void> {
    await this.apiService.delete(`diary/${id}`);
    await this.getClientDiaryUnread();
  }

  async getClientDiary(options?: {
    offset: string;
    limit: string;
    orderDir: 'asc' | 'desc';
    filterQuery: string;
    diarySortColumn?: 'created_at' | 'updated_at';
  }): Promise<GetDiarysResponse> {
    const url = queryString.stringifyUrl({
      url: 'diary',
      query: options
        ? {
            offset: options.offset,
            limit: options.limit,
            orderDir: options.orderDir,
            filterQuery: options.filterQuery !== '' ? options.filterQuery : undefined,
            diarySortColumn: options.diarySortColumn,
          }
        : {},
    });
    const response = await this.apiService.get(url);
    await this.getClientDiaryUnread();
    return response;
  }

  async getClientDiaryUnread(): Promise<GetUnreadDiarysResponse> {
    const response = await this.apiService.get('diary/unread');
    this.diaryUnread.next(response.unreadDiarys);
    return response;
  }
  async postClientDiaryReadAll(): Promise<void> {
    await this.apiService.post('diary/read/all');
    await this.getClientDiaryUnread();
  }
}
